// extracted by mini-css-extract-plugin
module.exports = {"frFinanceCopy":"LegalText_frFinanceCopy__QXUUg","campaignDisclaimer":"LegalText_campaignDisclaimer__6hgbv"};